import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home/home.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AutomobileRoutingModule } from './automobile.routing';
import { DealerComponent } from './dealer/dealer.component';
import { AutomobileGridComponent } from './automobile-grid/automobile-grid.component';
import { AutomobileDetailComponent } from './automobile-detail/automobile-detail.component';
import { DealerInfoComponent } from './dealer-info/dealer-info.component';
import { SharedModule } from 'src/app/shared.module';
import { MoreAddComponent } from './more-add/more-add.component';



@NgModule({
  declarations: [HomeComponent, PageNotFoundComponent, DealerComponent, AutomobileGridComponent, AutomobileDetailComponent, DealerInfoComponent, MoreAddComponent],
  imports: [
    CommonModule,
    SharedModule,
    AutomobileRoutingModule
  ],
  exports:[
    DealerInfoComponent
  ]
})
export class AutomobileModule { }
